"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TTL = void 0;
Object.defineProperty(exports, "cache", {
  enumerable: true,
  get: function () {
    return _memoryCache.default;
  }
});
exports.createCacheKey = createCacheKey;
var _memoryCache = _interopRequireDefault(require("memory-cache"));
// In milliseconds
let TTL = exports.TTL = /*#__PURE__*/function (TTL) {
  TTL[TTL["DAY"] = 86400000] = "DAY";
  TTL[TTL["HOUR"] = 3600000] = "HOUR";
  return TTL;
}({});
function createCacheKey(...keys) {
  return keys.filter(key => typeof key === 'string' || typeof key === 'number').join('_').toUpperCase();
}
//# sourceMappingURL=cache.js.map